<template>
  <el-form :class="['create-jobs-work', {disabled: !isEditable}]">
    <el-dialog append-to-body title="Создать работу" :visible.sync="open">
      <i class="el-icon-document-copy copy-job" @click="copyJob" v-if="isEditable && editId !== null"></i>
      <el-input placeholder="Название" :disabled="!isEditable" style="margin-bottom: 8px; margin-top: -42px" v-model="form.name"></el-input>
      <div style="display: flex">
        <el-input placeholder="План" :disabled="!isEditable" v-model="form.plan" style="margin-bottom: 8px"></el-input>
        <unit-select :disabled="!isEditable" hide-label style="margin-bottom: 8px; max-width: 120px; margin-left: 4px" v-model="form.unit"
                     placeholder="Eд. изм."/>
      </div>
      <el-input :disabled="!isEditable" v-model="form.comment" placeholder="Комментарий" type="textarea" textarea/>
      <i class="el-icon-circle-plus-outline work-job-plus" @click="createWorkType = true"/>
      <filter-select :disabled="!isEditable" label="Вид работ" style="margin-bottom: 0" :options="work_type_options" v-model="form.work_type"/>
      <el-form-item style="margin-bottom: 0px"
                    v-if="$store.getters.permission.price && this.$store.state.project.workorder.price"
                    :label="`${$store.getters.permission.price && $store.getters.permission.unit_name || 'Стоимость'} на ед. объема`">
        <el-input :disabled="!isEditable" v-model="form.price_unit" placeholder=""/>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px"
                    v-if="$store.getters.permission.price && this.$store.state.project.workorder.price"
                    label="Стоимость итого">
        <el-input :disabled="!isEditable" v-model="form.total_price" placeholder=""/>
      </el-form-item>

      <div class="tech-prof-container"
           v-if="this.$store.state.project.workorder.prof || this.$store.state.project.workorder.tech">
        <div class="tech-prof" v-if="this.$store.state.project.workorder.prof">
          <div style="display: flex">
            <strong style="margin-right: 8px">Численность</strong>
            <add-prof-tech :table="form.PROF || {}" type="PROF" @save="saveProf"/>
          </div>
          <el-input :disabled="!isEditable" v-model="form.PROF.total || 0" placeholder=""/>
        </div>
        <div class="tech-prof" v-if="this.$store.state.project.workorder.tech">
          <div style="display: flex">
            <strong style="margin-right: 8px">Техника</strong>
            <add-prof-tech :table="form.TECH || {}" type="TECH" @save="saveTech"/>
          </div>
          <el-input :disabled="!isEditable" v-model="form.TECH.total || 0" placeholder=""/>
        </div>
      </div>

      <div class="object-select">
        <strong style="color: #000; margin-top: 8px">Работа из плана</strong>
      </div>
      <div class="jobs-plan" @click="openSelectJob = isEditable ? true : false">
        <div v-if="form.job && form.job.name && form.originalId">
          {{ form.job.name }}
        </div>
        <div v-else></div>
        <div>
          <i class="fa fa-edit"></i>
        </div>
      </div>
      <el-dialog append-to-body title="Выбрать работу" :visible.sync="openSelectJob">
        <permission-jobs-work-object @select-job="selectJob" :select-only="true"/>
      </el-dialog>
      <div class="object-select" v-if="object && object.name">
        <div>{{ object.name }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="open = false">Закрыть</el-button>
          <el-button
            v-if="this.editId !== null && isEditable"
            @click="remove"
            type="danger"
          >Удалить
        </el-button>
        <el-button v-if="isEditable" type="primary" @click="save">Сохранить</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="Создать вид работ" :visible.sync="createWorkType">
      <CreateWorkType @save="saveCreateWork" @close="createWorkType = false" :isModal="true"/>
    </el-dialog>
  </el-form>
</template>

<script>

import FilterSelect from "../../../../components/FilterSelect";
import PermissionJobsWorkObject from "./PermissionJobsWorkObject";
import firebase from "firebase";
import UnitSelect from "../../components/unitSelect";
import _ from "lodash";
import {filterObjects} from "../../../../utils/filterJobs";
import {getChildList} from "../../../../utils/getChild";
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import AddProfTech from "./AddProfTech";
import {v4 as uuidv4} from "uuid";
import CreateWorkType from "../../WorkType/Create";
import {toFloat} from "../../../../utils/numberUtils";

export default {
  name: "CreateJobsWork",
  components: {CreateWorkType, AddProfTech, UnitSelect, PermissionJobsWorkObject, FilterSelect},
  props: ['isEditable'],
  data() {
    return {
      open: false,
      permission: {},
      structureObj: null,
      createWorkType: false,
      editId: null,
      form: {
        work_type: '',
        comment: '',
        job: null,
        name: '',
        price_unit: '',
        unit: null,
        total_price: '',
        TECH: {},
        PROF: {},
        originalId: null
      },
      object: null,
      list: [],
      work_type_options: [],
      isEdit: false,
      openSelectJob: false
    }
  },
  async mounted() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);
    if (!this.$store.state.project.version && !this.permission.usePermission) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, authFirestore.currentUser.uid, this.$store.state.project.plan && this.$store.state.project.plan.id);
    }
    this.fetchTree()
    this.getWorkType('job')

  },
  methods: {
    async saveCreateWork(id) {
      this.getWorkType('job', id)
      this.createWorkType = false
    },
    copyJob() {
      this.$emit('copy', {form: {...this.form, uid: uuidv4()}, structureObj: this.structureObj, isEdit: this.isEdit, editId: this.editId})
      this.open = false;
    },
    save() {
      this.$emit('save', {form: {uid: uuidv4(), ...this.form, plan: toFloat(this.form.plan)}, structureObj: this.structureObj, isEdit: this.isEdit, editId: this.editId})
      this.open = false;
    },
    remove() {
        this.$emit('remove', {
          structureObj: this.structureObj,
          isEdit: this.isEdit,
          editId: this.editId,
          removeId: this.form.reportId,

        })

        this.open = false;
    },
    openHandler(object, job, index, jobIndex) {
      this.isEdit = false
      this.form = {
        work_type: '',
        comment: '',
        job: {
          "objects": [object],
          "price_plan": 0,
          "work_type_name": "",
          "permission": {},
          "plan": 0,
          "start_date": null,
          "kind": null,
          "planID": null,
          "end_date": null,
          "price_unit": null,
          "ids_prof": [],
          "work_type": "",
          "type": "JOB",
          "project": {
            "end_date": null,
            "fact_volume": null,
            "start_date": null,
            "plan_volume": null
          },
          "index": 0,
          "volumes_tech": [],
          "name": "",
          "plan_tech": 0,
          "ids_tech": [],
          "volumes_prof": [],
          "unit_id": "",
          "volumes": [],
          "unit": "тн.",
          "plan_prof": 0
        },
        name: '',
        price_unit: '',
        unit: null,
        total_price: '',
        TECH: {},
        PROF: {},
        originalId: null,
      }
      this.editId = jobIndex
      this.open = true
      this.structureObj = index

      if (job) {
        this.form = {
          ...this.form,
          ...job
        }
        this.isEdit = true
      }
    },
    saveProf(p) {
      this.form.PROF = {...p}
    },
    saveTech(p) {
      this.form.TECH = {...p}
    },
    selectJob(e) {
      this.form.job = {
        ...e._data,
      }
      this.form = {
        ...this.form,
        originalId: e.id
      }
      this.openSelectJob = null
      if (e._data.objects && e._data.objects.length) {
        this.object = this.list.find((l) => l.id === e._data.objects[0])
      }

      if(this.form.job.work_type) {
        this.form.work_type = this.work_type_options.find(({value}) => value === this.form.job.work_type)
      }
    },
    fire() {
      if (this.$route.query.version) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);

        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    getWorkType(type, id) {

      console.log('GET_WORK_TYEP kk')

      return new Promise((resolve, reject) => {
        const result = [];
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          this.work_type_options = result;

          if(id) {
            this.form.work_type = this.work_type_options.find(({value}) => value === id)
          }
        });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.create-jobs-work {
  &.disabled {
    pointer-events: none;
  }
}

.tech-prof-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;

  .tech-prof {
    display: flex;
    color: #000000 !important;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;

    strong {
      color: #000 !important;
    }
  }
}

.jobs-plan {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  height: 40px;
  padding: 0 15px;
  align-items: center;
  box-sizing: border-box;
  margin-top: 8px;
  color: #000;
}

.object-select {
  display: flex;
  flex: 1;
  justify-content: flex-start;
}

.copy-job {
  position: relative;
  top: -60px;
  font-size: 18px;
  left: 145px;
  cursor: pointer;
}
.work-job-plus {
  position: relative;
  margin-left: 80px;
  cursor: pointer;
  font-size: 24px;
  margin-bottom: -30px;
  margin-top: 10px;
  display: flex;
  z-index: 2;
}
</style>
<style lang="scss">

.create-jobs-work {
  .el-form-item {
    margin-bottom: 8px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/CreateJobsWork.vue